import { createContext, useContext } from 'react';

const RichInputContext = createContext(null as any);

export const RichInputContextProvider = RichInputContext.Provider;

export const useRichInputContext = () => {
	const value = useContext(RichInputContext);
	if (!value) return {};
	return value;
};
